import React from 'react';
import { useTranslation } from 'react-i18next';
const SectionTitle = ({ title, lang }) => (
    // Usa h4, ou qualquer tag que você queira para títulos intermediários
    <h4 dangerouslySetInnerHTML={{__html: title[lang]}}></h4>
);

// 1. Definição do Componente Paragraph
const Paragraph = ({ text, lang }) => (
    <p dangerouslySetInnerHTML={{__html: text[lang]}}></p>
);

// 2. Definição do Componente ImageBlock
const ImageBlock = ({ imgSrc, alt, lang, className = '' }) => (
  <img src={imgSrc} alt={alt[lang]} className={`image-news-in-content ${className}`}  />
);

// Componentes existentes
const HeadingAndList = ({ title, list, lang }) => (
  <>
    {title && <h4 dangerouslySetInnerHTML={{__html: title[lang]}}></h4>}
    <ul className='list-news mb-2'>
      {list.map((listItem, listIndex) => (
        <li className='items-news' key={listIndex}  dangerouslySetInnerHTML={{__html: listItem.element[lang]}}>
        </li>
      ))}
    </ul>
  </>
);

const HtmlBlock = ({ title, text, lang }) => (
  <div className="inset-lg-right-35 inset-xxl-right-0 content-text">
    {title && <h4 dangerouslySetInnerHTML={{__html: title[lang]}}></h4>}
    {text && <p dangerouslySetInnerHTML={{__html: text[lang]}}></p>} 
  </div>
);

const ComparisonTable = ({ title, data, lang }) => {
    const { t, i18n } = useTranslation();
    // Lista auxiliar para renderizar itens
    const renderList = (list) => (
       <ul className='table-list-items'> 
            {list?.map((listItem, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: listItem.element[lang] }}>
                </li>
            ))}
        </ul>
    );
    // Verifica se há itens para renderizar
    if (!data.items || data.items.length === 0) return null;

    return (
        <div className="comparison-table-container my-4">
            {title && <h3 className='text-center'>{title[lang]}</h3>}
            <table className="comparison-table table table-bordered">
                
                {/* 1. CABEÇALHO DINÂMICO (Nome das tecnologias: SMD, COB, etc.) */}
                <thead>
                    <tr>
                        {data.items.map((item) => (
                            <th key={item.id} colSpan="2" className={`table-header-${item.id}`}>
                                {item.name[lang]}
                            </th>
                        ))}
                    </tr>
                </thead>
                
                {/* 2. CORPO DINÂMICO (Vantagens/Desvantagens) */}
                <tbody>
                    {/* Linha das subcategorias: Vantagens / Desvantagens */}
                    <tr>
                        {data.items.map((item) => (
                            // Repete 'Vantagens' e 'Desvantagens' para cada item
                            <React.Fragment key={`${item.id}-headers`}>
                                <td className="fw-bold bg-success-subtle">{t('noticia.vantagens')}</td>
                                <td className="fw-bold bg-danger-subtle">{t('noticia.desvantagens')}</td>
                            </React.Fragment>
                        ))}
                    </tr>

                    {/* Linha do conteúdo: Listas de Vantagens / Desvantagens */}
                    <tr>
                        {data.items.map((item) => (
                            // Repete o conteúdo para cada item
                            <React.Fragment key={`${item.id}-content`}>
                                <td className="table-content">{renderList(item.advantages)}</td>
                                <td className="table-content">{renderList(item.disadvantages)}</td>
                            </React.Fragment>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
// 3. Mapeamento de Tipos para Componentes (ADICIONE OS NOVOS TIPOS AQUI)
const componentMap = {
  headingAndList: HeadingAndList,
  htmlBlock: HtmlBlock,
  paragraph: Paragraph,  
  imageBlock: ImageBlock, 
  sectionTitle: SectionTitle,
  comparisonTable: ComparisonTable,
};

export const ContentRenderer = ({ blocks, lang }) => {
// ... (resto do código permanece igual)
    if (!blocks) return null;

    return (
        <>
            {blocks.map((block, index) => {
                const Component = componentMap[block.type];
                if (!Component) {
                    console.error(`Componente desconhecido: ${block.type}`, block); // Adicionei 'block' para debug
                    return null;
                }

                return (
                    <div className="content-text" key={index}>
                        <Component {...block} lang={lang} />
                    </div>
                );
            })}
        </>
    );
};